import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hamburger",
  "use": "icon-hamburger-usage",
  "viewBox": "0 0 67 45",
  "content": "<symbol viewBox=\"0 0 67 45\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-hamburger\">\n<path d=\"M0.526428 44.0164H66.239V36.715H0.526428V44.0164ZM0.526428 25.7629H66.239V18.4615H0.526428V25.7629ZM0.526428 0.208008V7.50941H66.239V0.208008H0.526428Z\" fill=\"#A7F900\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol